import { z } from 'zod';

import { CashLocationTypeSchema } from './cash-locations.schema.js';
import {
  CashReportCashLocationRefDtoSchema,
  CashReportCategoryBreakdownDtoSchema,
} from './cash-report-common.schema.js';
import type {
  CashPositionItemDto,
  CashPositionCustodyClassificationDto,
  CashPositionScope,
  CashPositionTotalsDto,
  GetCashPositionRequest,
  GetCashPositionResponse,
} from './cash-position.dto.js';
import { cashPositionScopeValues } from './cash-position.dto.js';

const timestampSchema = z.iso.datetime();

export const CashPositionScopeSchema: z.ZodType<CashPositionScope> =
  z.enum(cashPositionScopeValues);

export const CashPositionTotalsDtoSchema: z.ZodType<CashPositionTotalsDto> = z.object({
  totalIn: z.number().int().nonnegative(),
  totalOut: z.number().int().nonnegative(),
});

export const CashPositionCustodyClassificationDtoSchema: z.ZodType<CashPositionCustodyClassificationDto> =
  z.object({
    pendingTreasurySourceOffsetMinor: z.number().int().nonnegative(),
    awaitingDestinationConfirmationMinor: z.number().int().nonnegative(),
    activePreparedReservationMinor: z.number().int().nonnegative(),
    availableBalance: z.number().int(),
  });

export const CashPositionItemDtoSchema: z.ZodType<CashPositionItemDto> = z.object({
  cashLocationId: z.uuid(),
  kind: CashLocationTypeSchema,
  scope: CashPositionScopeSchema,
  storeId: z.uuid().nullable(),
  locationId: z.uuid().nullable(),
  stationId: z.uuid().nullable(),
  balance: z.number().int(),
  denominationInventoryActive: z.boolean(),
  lastMovementAt: timestampSchema.nullable(),
  totals: CashPositionTotalsDtoSchema.optional(),
  cashLocation: CashReportCashLocationRefDtoSchema.optional(),
  categoryBreakdown: z.array(CashReportCategoryBreakdownDtoSchema).optional(),
  custodyClassification: CashPositionCustodyClassificationDtoSchema.optional(),
});

export const GetCashPositionRequestSchema: z.ZodType<GetCashPositionRequest> = z.object({
  companyId: z.uuid(),
  storeId: z.uuid().optional(),
  locationId: z.uuid().optional(),
  stationId: z.uuid().optional(),
  includeStationScopedDrawers: z.coerce.boolean().optional(),
  includeZero: z.coerce.boolean().optional(),
  asOf: timestampSchema.optional(),
});

export const GetCashPositionResponseSchema: z.ZodType<GetCashPositionResponse> = z.object({
  items: z.array(CashPositionItemDtoSchema),
});
